///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Routes } from '@angular/router';

import { GtthCustomerComponent } from './customers.component';
import { UserAuthorities } from '../services/user/user-authorities';
import { canActivateUser } from '../shared/auth/user-route-access-service';
import { DialogAction } from '../dialog-manager/dialog-action-enum';
import { DeleteCustomerDialogWrapperComponent } from './dialogs/delete-customer-dialog/delete-customer-dialog-wrapper.component';
import { CreateCustomerDialogWrapperComponent } from './dialogs/create-or-edit-customer-dialog/create-customer-dialog-wrapper.component';
import { EditCustomerDialogWrapperComponent } from './dialogs/create-or-edit-customer-dialog/edit-customer-dialog-wrapper.component';
import { BlockCustomerDialogWrapperComponent } from './dialogs/block-customer-dialog/block-customer-dialog-wrapper.component';
import { CustomerLocationDialogWrapperComponent } from './dialogs/customer-location-dialog/customer-location-dialog-wrapper.component';
import { EditCustomerRestrictionsDialogWrapperComponent } from './dialogs/restrictions-dialog/edit-customer-restrictions-dialog-wrapper.component';

const pageTitle = 'customer.home.title';

export const CUSTOMERS_BASE_URL = 'customers';

export const customerRoute: Routes = [
    {
        path: '',
        component: GtthCustomerComponent,
        data: {
            tabName: CUSTOMERS_BASE_URL,
            authorities: UserAuthorities.ALL_SIKLU,
            pageTitle
        },
        canActivate: [canActivateUser]
    }
];

export const customerPopupRoute: Routes = [
    {
        path: `${DialogAction.CREATE}/customer`,
        component: CreateCustomerDialogWrapperComponent,
        data: {
            authorities: UserAuthorities.ALL_SIKLU,
            pageTitle
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    },
    {
        path: `${DialogAction.EDIT}/customer/:id`,
        component: EditCustomerDialogWrapperComponent,
        data: {
            authorities: UserAuthorities.ALL_SIKLU,
            pageTitle
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    },
    {
        path: `${DialogAction.DELETE}/customer/:id`,
        component: DeleteCustomerDialogWrapperComponent,
        data: {
            authorities: UserAuthorities.ALL_SIKLU,
            pageTitle
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    },
    {
        path: `${DialogAction.BLOCK}/customer/:id`,
        component: BlockCustomerDialogWrapperComponent,
        data: {
            authorities: UserAuthorities.ALL_SIKLU,
            pageTitle
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    },
    {
        path: 'locations',
        component: CustomerLocationDialogWrapperComponent,
        data: {
            authorities: [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT],
            pageTitle
        },
        canActivate: [canActivateUser],
        outlet: 'popup'
    },
    {
        path: `customer-restrictions`,
        component: EditCustomerRestrictionsDialogWrapperComponent,
        outlet: 'popup',
        data: {
            authorities: [UserAuthorities.SIKLU_ADMIN, UserAuthorities.SIKLU_ACCOUNTANT]
        },
        canActivate: [canActivateUser]
    }
];
